export * from './daughter/daughter.component';
export * from './son/son.component';
export * from './wife/wife.component';
export * from './father/father.component';
export * from './mother/mother.component';
export * from './husband/husband.component';